import React from "react";
import NavBar from "./NavBar";

function Header(props) {
  return (
    <header className="header-container">
      <NavBar />
    </header>
  );
}

export default Header;
